import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import "./VerticalCard.css";
import "./Card.css";
import { NavLink } from "react-router";
import { Button } from "../ui/button";

const VerticalCard = ({
  lottieSrc,
  title,
  description,
  badges,
  buttonText,
  buttonLink,
}: {
  lottieSrc: string;
  title: string;
  description: string;
  badges?: string[];
  buttonText?: string;
  buttonLink?: string;
}) => {
  return (
    <div className="card-vertical">
      <DotLottieReact
        src={lottieSrc}
        loop
        autoplay
        className="lottie-container"
      />
      <div className="vertical-card-text">
        <h3>{title}</h3>
        <p>{description}</p>
        {badges && (
          <div className="badges">
            <div className="badge-scroll">
              {badges.concat(badges).map(
                (
                  badge,
                  index // Duplicate badges for smooth looping
                ) => (
                  <div key={index} className="badge">
                    {badge}
                  </div>
                )
              )}
            </div>
          </div>
        )}
        {/* Conditionally wrap the button in NavLink if buttonLink exists */}
        {buttonText &&
          (buttonLink ? (
            <NavLink to={buttonLink} className="nav-button">
              <Button variant="secondary" size="md" className="white">
                {buttonText}
              </Button>
            </NavLink>
          ) : (
            <Button variant="secondary" size="md" className="white">
              {buttonText}
            </Button>
          ))}
      </div>
    </div>
  );
};

export default VerticalCard;
